export const isDemoMode = process.env.REACT_APP_DEMO_MODE === 'true';

export const demoSharedApiUrl = process.env.REACT_APP_DEMO_SHARED_API_URL || '';

export const demoSharedTenant = process.env.REACT_APP_DEMO_TENANT || 'customer-a';

export const isSharedDemoMode = isDemoMode && Boolean(demoSharedApiUrl);

export const demoModeLabel = 'Demo Environment';
